module.exports = __webpack_public_path__ + "img/83.a0e9c47d.svg";